import api from './api';

const assistenteService = {
  perguntar: async (payload) => {
    const response = await api.post('/api/assistente/perguntar', payload);
    return response.data;
  }
};

export default assistenteService;